export default __webpack_public_path__ + "static/media/unselected4.4777b943.png";